module.exports = __webpack_public_path__ + "nc_static/media/notFound.f0e9355f.png";